module.exports = __webpack_public_path__ + "static/palace-of-tears-45886da5d2faba051cc9c88d6ee56692.jpg";